import axios from '@axios'
import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchMessages(ctx, datas){
        return new Promise((resolve, reject) => {
            axiosIns.get('/message/list',{params:datas})
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    updateMessage(ctx,data){
        return new Promise((resolve, reject) => {
            axiosIns.patch('/message',data).then(response => resolve(response)).catch(error=>reject(error))
        })
    },
    deleteMessage(ctx,id){
        return new Promise((resolve, reject) => {
            axiosIns.delete('/message/'+id).then(response => resolve(response)).catch(error=>reject(error))
        })
    },
  },
}
